import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

interface PrivateRouterProps extends RouteProps {
  children: any,
}

function PrivateRouter({ children, ...rest }: PrivateRouterProps) {
  const auth = true;

  return <Route
    {...rest}
    render={({ location }) => auth ? children : (
      <Redirect
        to={{
          pathname: '/',
          state: { from: location }
        }}
      />
    )}
  />
}

export default PrivateRouter;
